import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

import type { QuestionnaireView } from '@/models/onboarding'
import type { HabitOptions20710Page } from '@/models/onboarding.types'

import Layout from '../Layout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'HabitOptions20710',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => props.view.currentPage as HabitOptions20710Page)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    title: page.value.title
  }, null, 8, ["title"]))
}
}

})